import type { SVGProps } from "react";
import * as React from "react";

const SvgCloudSnow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cloud-snow_svg__a)">
      <path
        fill="currentColor"
        d="M19.599 16.664a1 1 0 1 0 .802 1.832zM18 8l.001-1H18zm-1.26 0-.968.25a1 1 0 0 0 .968.75zM3.376 17.031a1 1 0 1 0 1.248-1.562zM8 15a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM8 19a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM12 17a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM12 21a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM16 15a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM16 19a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zm4.391-2.504a6 6 0 0 0 2.926-2.746l-1.778-.917a4 4 0 0 1-1.95 1.831zm2.926-2.746a6 6 0 0 0 .54-3.976l-1.957.409a4 4 0 0 1-.36 2.65zm.54-3.976a6 6 0 0 0-2.086-3.428L20.52 9.897a4 4 0 0 1 1.39 2.285zm-2.086-3.428A6 6 0 0 0 18.001 7L18 9a4 4 0 0 1 2.52.897zM18 7h-1.26v2H18zm-.292.75a9 9 0 0 0-1.983-3.724L14.23 5.354a7 7 0 0 1 1.543 2.896zm-1.983-3.724a9 9 0 0 0-3.462-2.411l-.726 1.863a7 7 0 0 1 2.692 1.876zm-3.462-2.411a9 9 0 0 0-4.18-.568l.202 1.99a7 7 0 0 1 3.252.441zm-4.18-.568a9 9 0 0 0-3.98 1.399l1.086 1.679a7 7 0 0 1 3.096-1.089zm-3.98 1.399a9 9 0 0 0-2.906 3.06l1.733.998a7 7 0 0 1 2.26-2.38zm-2.906 3.06A9 9 0 0 0 .005 9.552l1.998.1a7 7 0 0 1 .927-3.149zM.005 9.552a9 9 0 0 0 .784 4.145l1.823-.822a7 7 0 0 1-.61-3.224zm.784 4.145a9 9 0 0 0 2.587 3.333l1.248-1.562a7 7 0 0 1-2.012-2.592zM8 17h.01v-2H8zm0 4h.01v-2H8zm4-2h.01v-2H12zm0 4h.01v-2H12zm4-6h.01v-2H16zm0 4h.01v-2H16z"
      />
    </g>
    <defs>
      <clipPath id="cloud-snow_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCloudSnow;
